/* global APPLICATION_CONFIG */

import c from "./consts";
import http from "@/api/http";

const SELECTED_COMPANY_ID_KEY =
    "selectedAdminCompanyId";

export default {
    async [c.GET_COMPANIES]({
                                state,
                                commit,
                            }) {
        commit(c.IS_LOADING, true);

        try {
            const response = await http.get(
                `${APPLICATION_CONFIG.api.administratorURL}/get-companies`
            );

            const companies = response.data;

            commit(c.COMPANIES, companies);

            const selectedCompanyId =
                state[c.SELECTED_COMPANY]?.id ||
                localStorage.getItem(
                    SELECTED_COMPANY_ID_KEY
                );

            if (selectedCompanyId) {
                const selectedCompany =
                    companies.find(
                        company =>
                            company.id ===
                            selectedCompanyId
                    ) || null;

                commit(
                    c.SELECTED_COMPANY,
                    selectedCompany
                );

                if (!selectedCompany) {
                    localStorage.removeItem(
                        SELECTED_COMPANY_ID_KEY
                    );
                }
            }

            return companies;
        }
        catch (error) {
            commit(c.COMPANIES, []);
            commit(c.SELECTED_COMPANY, null);

            throw error;
        }
        finally {
            commit(c.IS_LOADING, false);
        }
    },

    [c.SELECT_COMPANY]({ commit }, company) {
        commit(
            c.SELECTED_COMPANY,
            company
        );

        if (company?.id) {
            localStorage.setItem(
                SELECTED_COMPANY_ID_KEY,
                company.id
            );
        }
        else {
            localStorage.removeItem(
                SELECTED_COMPANY_ID_KEY
            );
        }
    },
};